import React from "react";

function BubbleSection() {
  return (
    <section className="bubblesection">
      <div className="bubble-wrapper">
        <p>
          Utility-meme-tokens are useful and fun. The success of SquidGrow is
          based on a strong community, team, and its experience, vision
          development of utilities, and strategy.
        </p>
      </div>
    </section>
  );
}

export default BubbleSection;
